<template>
	<router-view ref="child" />
</template>
<script>
export default {
	name: 'App',
	mounted: function () {
		this.table_height();
	},
	// 事件
	methods: {
		table_height() {
			var this_ = this;
			var winHeight;
			var chazhi = 50 + 20 + 47 + 66;
			if (window.innerHeight) {
				winHeight = window.innerHeight;
			} else if ((document.body) && (document.body.clientHeight)) {
				winHeight = document.body.clientHeight;
			}
			if (document.documentElement && document.documentElement.clientHeight) {
				winHeight = document.documentElement.clientHeight;
			}
			sessionStorage.setItem('table_height', winHeight - chazhi);
			window.onresize = () => {
				return (() => {
					this_.$nextTick(function () {
						if (window.innerHeight) {
							winHeight = window.innerHeight;
						} else if ((document.body) && (document.body.clientHeight)) {
							winHeight = document.body.clientHeight;
						}
						if (document.documentElement && document.documentElement.clientHeight) {
							winHeight = document.documentElement.clientHeight;
						}
						sessionStorage.setItem('table_height', winHeight - chazhi);
						if (this_.$refs.child&&this_.$refs.child.headHeight) {
							this_.$refs.child.headHeight();
						}
					})
				})()
			}
		},
	},
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue